import { getOS } from '../../common/user-agent-helpers'
import { WindowsSupportBannerService } from '../../services/banner/windows-support-banner-service'
import { isWindowsContainer } from '../../services/container/helpers'
import { getLaunchDarklyFlag } from '../../services/feature-flags'
import { LaunchDarklyVariations } from '../../services/feature-flags/models'

export const initializeWindowsSupportBanner = () => {
  const winSupportBannerService = new WindowsSupportBannerService()
  return canShowWindowsSupportBanner() ? winSupportBannerService.show() : winSupportBannerService.hide()
}

/**
 * Verifies if the user is on a windows desktop version below than 10
 * @returns true/false
 */
const canShowWindowsSupportBanner = (): boolean => {
  if (!getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_DISPLAY_WINDOWS_SUPPORT_BANNER)) {
    return false
  }
  const osMajorVersion = Number(getOS().major)
  return isWindowsContainer() && osMajorVersion < 10
}
